import { useDispatch, useSelector } from 'react-redux'
import { Switch } from '../../common/html/switch'
import { changeSetting, selectCellDataById } from '../store/slice'
import { postUserNotificationSettings } from '../store/thunk'

const ROW_ID_HAS_SWITCH = ['1', '2', '3']

const SwitchCell = ({ checked, rowId, colId }) => {
  const dispatch = useDispatch()

  const dataRow = useSelector(selectCellDataById(rowId))

  const updateSetting = (enable) => {
    dispatch(
      postUserNotificationSettings({
        notificationTypeId: rowId,
        receiveNotification: enable,
        receiveEmail: dataRow.receiveEmail,
      }),
    )
      .unwrap()
      .then(() => {
        dispatch(
          changeSetting({
            rowId,
            keySetting: colId,
            newSetting: !checked,
          }),
        )
      })
      .catch(() => {})
  }

  if (!ROW_ID_HAS_SWITCH.includes(rowId)) return null

  return <Switch checked={checked} onChange={updateSetting} />
}

export default SwitchCell
